module.exports = __webpack_public_path__ + "static/media/udatatrack-illustrator.a4179a06.svg";